import { createSelector } from 'reselect';
import { StateType } from 'containers/Portfolio/PageHeader/reducer';
import { BrandType } from 'utils/types';

const getReducer = state => state.portfolioPageHeader;

export const brandsSelector = createSelector<StateType, Array<BrandType>, Array<BrandType>>(
  state => getReducer(state).brands,
  brands => brands
);

export const selectedBrandsSelector = createSelector<StateType, Array<string>, Array<string>>(
  state => getReducer(state).selectedBrands,
  selectedBrands => selectedBrands
);

export const showBrandFilterSelector = createSelector<StateType, boolean, boolean>(
  state => getReducer(state).showBrandFilter,
  showBrandFilter => showBrandFilter
);

export const showBrandPickerSelector = createSelector<StateType, boolean, boolean>(
  state => getReducer(state).showBrandPicker,
  showBrandPicker => showBrandPicker
);

export const transientSelectedBrandsSelector = createSelector<
  StateType,
  Array<string>,
  Array<string>
>(
  state => getReducer(state).transientSelectedBrands,
  transientSelectedBrands => transientSelectedBrands
);
